import { animate, query, style, transition, trigger } from '@angular/animations';

export const routeTransitionAnimation = trigger('routeTransition', [
  transition('login => main', [
    style({ position: 'relative' }),
    query(
      ':enter, :leave',
      [
        style({
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
        }),
      ],
      { optional: true },
    ),

    // Hide the entering page initially
    query(':enter', [style({ opacity: 0 })], { optional: true }),

    // Fade out login page
    query(':leave', [animate('300ms ease-in', style({ opacity: 0 }))], {
      optional: true,
    }),

    // After login fades out, show entering page with delayed fade in
    query(':enter', [animate('2300ms 300ms ease-in', style({ opacity: 1 }))], {
      optional: true,
    }),
  ]),
]);
